import {UserOPEEnum} from "../UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DataTypeGroupEnum} from "../../../enums/dashboard/DataTypeUnitEnum";
import {DataQuantityEnum} from "../../../enums/dashboard/DataQuantityEnum";
import {MetricDataUnitEnum} from "../../../enums/dashboard/MetricDataUnitEnum";
import {BucketUnitEnum} from "../../../enums/dashboard/ChartsEnum";
import {TypeOfDateSettingsEnumCharts} from "../../../enums/dashboard/TypeOfDateSettingsEnumCharts";
import {TimeUnitEnum} from "../../../enums/dashboard/TimeUnitEnum";

// Shared with GetAllUserMetricGroupCB, the impersonation-aware variant: same payload, only the
// visibility rule differs, and UserMetricGroup is built from either
export class UserMetricGroupDetailDTO {
  id!: number;
  name!: string;
  bucketUnits!: BucketUnitEnum;
  bucketValue!: number;
  metrics: UserMetricDTO[];
  timeInterval!: TimeIntervalDTO;

  constructor() {
    this.metrics = [];
  }
}

export interface UserMetricGroupDetailCB {
  o: UserMetricGroupDetailDTO;
}

class UserMetricDTO {
  metricInstance!: UserMetricInstanceDTO;
  functionType!: string;
  color!: string;
  chartType!: string;
  uniqueCode!: string;
}

class UserMetricInstanceDTO {
  partitionId!: number;
  partitionName!: string;
  deviceId!: number;
  deviceName!: string;
  id!: number;
  type!: string;
  name!: string;
  dataTypeGroup!: DataTypeGroupEnum;
  dataTypeGroupShowAsHex!: boolean;
  dataUnit!: MetricDataUnitEnum;
  decimalDigits!: number | null;
  dataQuantity!: DataQuantityEnum;
  lastValueTs!: number | null;
  lastValue!: number | null;
}

export class TimeIntervalDTO {
  startDate!: number;
  endDate!: number;
  selectedDateSettings!: TypeOfDateSettingsEnumCharts;
  realTimeUnit!: TimeUnitEnum;
  realtimeValue!: number;
}

/**
 * O Inner Class
 */
class I {
  id!: number;
}


/**
 * GetTransportItemDetailCB class
 */
export class GetUserMetricGroupCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: UserMetricGroupDetailDTO;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.GetUserMetricGroup);
    this.i = new I();
    this.o = new UserMetricGroupDetailDTO();
  }

}
